import http from '@utils/request'
// import { getEncrypt } from '@/utils/rsa'
import apiPath from './api-path'

const { yhzxApi, clientKey, clientFlag } = apiPath

// 登录
export const login = ({ username, password, mode = 'account_password' }) => http.postForm({
    url: '/oauth/token',
    data: {
        codeKey: username,
        username,
        password,
        grant_type: 'password',
        mode
    },
    auth: {
        username: clientKey,
        password: clientFlag
    },
    baseURL: yhzxApi
})

// 修改密码
export const updateUserPassword = ({ oldPassword, newPassword }) => http.put({
    url: '/users/me/password/by-old-password',
    data: {
        oldPassword,
        newPassword
    },
    baseURL: yhzxApi
})

// 查询用户信息
export const queryUserInfo = () => http.get({
    url: '/users/me',
    baseURL: yhzxApi
})

//获取动态路由菜单
export const queryUserMenu = () => http.get({
    url: '/menus/my',
    baseURL: yhzxApi
})

// 获取登录二维码
export const queryQrcode = () => http.get({
    url: `/scancode/getCode?clientId=${ clientFlag }`,
    baseURL: yhzxApi
})

// 轮询登录信息
export const pollingLoginInfo = code => http.get({
    url: `/scancode/getScanLoginInfo?code=${ code }`,
    baseURL: yhzxApi
})

// 图片上传
export const uploadFiles = data => http.postFormData({
    url: '/files',
    data,
    baseURL: yhzxApi
})

